import { render, staticRenderFns } from "./historyLog.vue?vue&type=template&id=66d8a6ca&"
import script from "./historyLog.vue?vue&type=script&lang=js&"
export * from "./historyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports